import React, { useEffect, useState } from "react";
import "./Management.css";
import { useLoader } from "../../../../context/LoaderProvider";
import * as XLSX from "xlsx"; // ✅ for Excel export

function Cateringpackagesorders() {
    const { showLoader, hideLoader } = useLoader();
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        if (!token) {
            console.error("No auth token found in localStorage!");
            return;
        }

        const fetchOrders = async () => {
            try {
                showLoader();
                const res = await fetch(
                    `https://backend.maamaas.com/catering/api/vendor/getall/${vendorId}`,
                    {
                        method: "GET",
                        headers: {
                            Accept: "*/*",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                const data = await res.json();

                const preparingOrders = data.filter(
                    (order) =>
                        order.paymentStatus === "SUCCESS" && order.orderStatus === "DELIVERED"
                );

                setOrders(preparingOrders);
                setFilteredOrders(preparingOrders);
            } catch (err) {
                console.error("❌ Error fetching orders:", err);
            } finally {
                hideLoader();
            }
        };

        fetchOrders();
    }, []);

    // ✅ Filter orders by selected date
    useEffect(() => {
        if (!selectedDate) {
            setFilteredOrders(orders);
        } else {
            showLoader();
            const filtered = orders.filter((order) => {
                const orderDate = new Date(order.orderDateTime);
                const yyyy = orderDate.getFullYear();
                const mm = String(orderDate.getMonth() + 1).padStart(2, "0");
                const dd = String(orderDate.getDate()).padStart(2, "0");
                return `${yyyy}-${mm}-${dd}` === selectedDate;
            });
            setFilteredOrders(filtered);
            setTimeout(() => hideLoader(), 200);
        }
    }, [selectedDate, orders]);

    // ✅ Export filtered orders to Excel
    const exportToExcel = () => {
        if (filteredOrders.length === 0) {
            alert("No data available to export!");
            return;
        }

        const exportData = filteredOrders.map((order) => {
            const dateObj = new Date(order.orderDateTime);
            const date = dateObj.toLocaleDateString("en-IN");
            const time = dateObj.toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            });
            const firstPackage = order.orderItems?.[0];
            const firstItem = firstPackage?.packageItems?.[0];

            return {
                "Order ID": order.orderId,
                "User ID": order.userId,
                Location: order.location || "-",
                Date: date,
                Time: time,
                "Payment Method": order.paymentMethod || "-",
                Subtotal: order.subtotal?.toFixed(2) || 0,
                Total: order.total?.toFixed(2) || 0,
                "Package Name": firstPackage?.packageName || "-",
                "Package Type": firstPackage?.packageType || "-",
                "Package Price": firstPackage?.packagePrice || 0,
                Quantity: firstPackage?.quantity || 0,
                "Item Name": firstItem?.itemName || "-",
                "Item Price": firstItem?.price || 0,
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
        XLSX.writeFile(
            workbook,
            `PreparingOrders_${new Date().toISOString().split("T")[0]}.xlsx`
        );
    };

    return (
        <div>
            {/* 📅 Filter & Export Controls */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginBottom: "10px",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <input
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        style={{
                            padding: "6px 10px",
                            fontSize: "14px",
                            background: "#b15dc6",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                        }}
                    />

                    {selectedDate && (
                        <button
                            onClick={() => setSelectedDate("")}
                            style={{
                                padding: "6px 10px",
                                backgroundColor: "#b15dc6",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                        >
                            Clear
                        </button>
                    )}
                </div>

                <button
                    onClick={exportToExcel}
                    style={{
                        padding: "8px 14px",
                        background: "#b15dc6",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "14px",
                    }}
                >
                    Export to Excel
                </button>
            </div>

            {/* 🧾 Orders Table */}
            <div
                style={{
                    overflowX: "auto",
                    overflowY: "hidden",
                    scrollbarWidth: "thin",
                }}
            // className="catering-package-table"
            >
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "5px",
                        fontSize: "14px",
                    }}
                >
                    <thead>
                        <tr style={{ backgroundColor: "rgb(177 93 198)", color: "white" }}>
                            <th>Order ID</th>
                            <th>User ID</th>
                            <th>Location</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Payment Method</th>
                            <th>Subtotal</th>
                            <th>Total</th>
                            <th>Package Name</th>
                            <th>Package Type</th>
                            <th>Package Price</th>
                            <th>Quantity</th>
                            <th>Item Name</th>
                            <th>Item Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredOrders.length > 0 ? (
                            filteredOrders.map((order) => {
                                const dateObj = new Date(order.orderDateTime);
                                const date = dateObj.toLocaleDateString("en-IN", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                });
                                const time = dateObj.toLocaleTimeString("en-IN", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                });

                                const firstPackage = order.orderItems?.[0];
                                const firstItem = firstPackage?.packageItems?.[0];

                                return (
                                    <tr key={order.orderId}>
                                        <td style={tdStyle}>{order.orderId}</td>
                                        <td style={tdStyle}>{order.userId}</td>
                                        <td style={tdStyle}>{order.location || "-"}</td>
                                        <td style={tdStyle}>{date}</td>
                                        <td style={tdStyle}>{time}</td>
                                        <td style={tdStyle}>{order.paymentMethod || "-"}</td>
                                        <td style={tdStyle}>{order.subtotal?.toFixed(2) || 0}</td>
                                        <td style={tdStyle}>{order.total?.toFixed(2) || 0}</td>
                                        <td style={tdStyle}>{firstPackage?.packageName || "-"}</td>
                                        <td style={tdStyle}>{firstPackage?.packageType || "-"}</td>
                                        <td style={tdStyle}>{firstPackage?.packagePrice || 0}</td>
                                        <td style={tdStyle}>{firstPackage?.quantity || 0}</td>
                                        <td style={tdStyle}>{firstItem?.itemName || "-"}</td>
                                        <td style={tdStyle}>{firstItem?.price || 0}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="14" style={{ textAlign: "center", padding: "10px" }}>
                                    No preparing orders found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

// ✅ Internal table cell styles
const tdStyle = {
    border: "1px solid #ccc",
    padding: "6px",
    textAlign: "center",
};

export default Cateringpackagesorders;
